/**
 * JWT `pages` is stored as a comma-separated string. Use token-level checks
 * instead of substring matching on the whole string.
 */
export function parsePageTokens(pages: string | null): string[] {
  if (!pages) return [];
  return pages
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean);
}

export function hasPageToken(pages: string | null, token: string): boolean {
  return parsePageTokens(pages).includes(token);
}

/** Finance drawer: parent token `finance` or any child `finance-*` (e.g. finance-funds). */
export function hasFinanceSection(pages: string | null): boolean {
  const tokens = parsePageTokens(pages);
  if (tokens.includes('finance')) return true;
  return tokens.some((t) => t.startsWith('finance-'));
}
